import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    filtersData: {
        objectRange: null as any,
        objectRangeValue: null as any,
        usersData: [] as any,
        objectRangeUser: null as any,
        objectRangeSupplier: null as any,
        objectRangeTeam: null as any,
        personRange: '' as string,
        personBalance: {from: null, to: null} as any,
        bookingAmount: {from: null, to: null} as any,
        KKL: '' as string,
        typeSumm: '' as string,
        showExtendedBalance: false,
        directLoad: false,
        activeButtonId: null,
        userteamId: null,
        lookupName: '' as string,
        isChecked: false as boolean,
        teamShortName: null as any,
        timeRange: null as any,
        dateFrom: null as any,
        dateTo: null as any,
    },
    activeDivRef: null as any
}

const clearingFiltersSlice = createSlice({
    name: 'clearingFilters',
    initialState,
    reducers: {
        setFiltersData: (state, action) => {
            state.filtersData = {...state.filtersData, ...action.payload}
        },
        setActiveDivRef: (state, action) => { 
            state.activeDivRef = action.payload
        }
    }
})

export const { setFiltersData, setActiveDivRef } = clearingFiltersSlice.actions
export default clearingFiltersSlice.reducer
